import React from "react";
import { Box } from "@mui/material";

import imgLogo from "../../assets/images/logo.png";

const Loading = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        backgroundColor: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src={imgLogo} />
    </Box>
  );
};

export default Loading;
